import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Skeleton, Subheading } from '@treams/treams-ui';

import LearningItemCard from './LearningItemCard';

const SUGGESTION_COUNT = 4;

export default function LearningRecommendations(props: {
	available: boolean;
	loading: boolean;
	recommendations: {
		reason?: string | null;
		learningCourse: graphql.LearningCourseFragment;
	}[];
}) {
	const { t } = useTranslation();

	if (!props.available) {
		return null;
	}

	const showSkeletons = props.loading && props.recommendations.length === 0;

	if (!showSkeletons && props.recommendations.length === 0) {
		return null;
	}

	return (
		<Box mb={[4, 4, 5]}>
			<Subheading>{t('learning.recommendations.title')}</Subheading>

			<Flex ml={-3} flexWrap="wrap">
				{showSkeletons ? (
					<Skeleton.Repeat count={SUGGESTION_COUNT}>
						<Box width={[1, 1 / 2, 1 / 4, 1 / 4]} mt={3} pl={3}>
							<LearningItemCard.Skeleton />
						</Box>
					</Skeleton.Repeat>
				) : (
					props.recommendations.map((recommendation) => (
						<Box
							key={recommendation.learningCourse.id}
							width={[1, 1 / 2, 1 / 4, 1 / 4]}
							mt={3}
							pl={3}
							title={recommendation.reason ?? undefined}
						>
							<LearningItemCard course={recommendation.learningCourse} />
						</Box>
					))
				)}
			</Flex>
		</Box>
	);
}
